function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4ou2bh09ya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8513",
    transform: "translate(1465 6390)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h173v173H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 159",
    transform: "translate(-1465 -6390)",
    style: {
      clipPath: "url(#4ou2bh09ya)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10381"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46330",
    d: "M128.849 33.191c1.108-.534 4.3-2.012 5.721-2.65-.16.694-.32 1.389-.488 2.08-.4 1.663-.853 3.559-1.319 5.518-.831 3.5-1.69 7.119-2.429 10.048-1.152 4.57-2.473 9.244-3.532 12.5a9.5 9.5 0 0 1-7.555 6.744 49.557 49.557 0 0 1-8.76.488c2.271-2.112 4.59-4.913 5.012-5.247l.552-.031a7.839 7.839 0 0 0 3.692-.817 5.389 5.389 0 0 0 2.45-3.258c.835-3.439 2-7.7 3.047-11.817.989-3.9 2.011-7.924 2.808-11.193l.547-2.247z",
    transform: "translate(1402.286 6426.834)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46331",
    d: "M386.444 39.538a39.927 39.927 0 0 0-7.465.315 9.874 9.874 0 0 0-7.849 7.006c-1.1 3.386-3.04 11.422-3.459 13.15-.174.719-.229 1.178-.394 1.9h5.529s2.155-9.272 3.023-12.845a4.828 4.828 0 0 1 2.321-3.164 10.472 10.472 0 0 1 3.026-.716z",
    transform: "translate(1249.557 6421.506)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46332",
    d: "M234.912 40.519a8.5 8.5 0 0 0-7.038.038c-5.785 2.322-9.585 8.933-8.84 15.377a6.365 6.365 0 0 0 5.71 5.957c1.051.1 2.055.079 3.223.094l.517-.026c.064-.022.1-.259.227-.78.11-.457.9-3.827 1.162-4.934l.168-.72h-.009c-.415.107-.8.2-1.183.284a3.75 3.75 0 0 1-2.992-.553 2.9 2.9 0 0 1-1.151-2.1 6.609 6.609 0 0 1 2.859-6.429 3.928 3.928 0 0 1 4.411-.162c1.911 1.167 1.25 3.646.846 5.409q-.469 2.047-.947 4.092c-.394 1.672-.957 3.558-1.5 5.38-.532 1.782-1.083 3.625-1.469 5.249l-1.284 5.4s5.875-3.485 6.16-3.659l.156-.649c.525-2.2 1.2-4.589 1.859-6.9.774-2.729 1.574-5.55 2.145-8.122a28.775 28.775 0 0 0 .844-5.945 6.51 6.51 0 0 0-3.874-6.305",
    transform: "translate(1337.781 6421.341)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46333",
    d: "M186.029 46.43a6.951 6.951 0 0 0-2.229-4.83 8.611 8.611 0 0 0-.271-.229 7.15 7.15 0 0 0-4.587-1.653 10.4 10.4 0 0 0-3.834.818c-5.474 2.178-9.153 8.08-8.948 14.353a7.369 7.369 0 0 0 2.313 5.444A7.244 7.244 0 0 0 173.34 62v.005c.576.013 1.165.012 1.8.021l.55-.026c.029-.011 1.57-6.506 1.57-6.506-.4.1-.777.192-1.155.273a3.743 3.743 0 0 1-3.039-.554 2.979 2.979 0 0 1-1.174-2.206 6.589 6.589 0 0 1 2.53-6.017 5.23 5.23 0 0 1 2.424-.958 3.224 3.224 0 0 1 2.6.644 3.305 3.305 0 0 1 1.027 2.549 8.369 8.369 0 0 1-.1 1.322c-.043.289-.095.585-.166.891q-.543 2.344-1.108 4.682l-.457 1.911-.742 3.449a7.356 7.356 0 0 0-.093.482h5.24l2.215-9.59.088-.363a19.737 19.737 0 0 0 .72-4.825c0-.252-.015-.5-.037-.755",
    transform: "translate(1369.181 6421.375)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46334",
    d: "M339.481 46.43a6.951 6.951 0 0 0-2.233-4.829 7.604 7.604 0 0 0-.271-.229 7.149 7.149 0 0 0-4.587-1.653 10.408 10.408 0 0 0-3.835.818c-5.474 2.178-9.153 8.08-8.948 14.353a7.369 7.369 0 0 0 2.313 5.444A7.243 7.243 0 0 0 326.792 62v.005c.576.013 1.165.012 1.8.021l.55-.026c.029-.011 1.57-6.506 1.57-6.506-.4.1-.777.192-1.155.273a3.742 3.742 0 0 1-3.039-.554 2.977 2.977 0 0 1-1.174-2.206 6.587 6.587 0 0 1 2.53-6.017 5.225 5.225 0 0 1 2.423-.958 3.225 3.225 0 0 1 2.6.644 3.3 3.3 0 0 1 1.027 2.549 8.32 8.32 0 0 1-.1 1.322c-.043.289-.1.585-.166.891q-.543 2.344-1.107 4.682l-.458 1.911-.749 3.451a7.356 7.356 0 0 0-.093.482h5.24l2.215-9.59.088-.363a19.773 19.773 0 0 0 .72-4.825c0-.252-.015-.5-.037-.755",
    transform: "translate(1277.913 6421.375)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46335",
    d: "M290.21 40.26c-1.291 0-2.541.03-3.79.009h-.014c-.389-.006-.41-.022-.43.045-.013.043.009-.019-.084.373-.964 4.064-1.953 8.486-2.829 12.067A4.778 4.778 0 0 1 280.2 56.3a2.952 2.952 0 0 1-3.034-.314 2.776 2.776 0 0 1-.855-2.777c.419-2.13 2.92-12.914 2.92-12.914h-5.267s-1.791 7.863-2.37 10.241a18.324 18.324 0 0 0-.784 5.759 6.37 6.37 0 0 0 1.941 4.353c2.181 2.023 4.817 2.367 8.059 1.051a11.69 11.69 0 0 0 3.53-2.214c.113-.1.22-.212.329-.32.056-.055.114-.107.168-.163a13.81 13.81 0 0 0 3.023-5.026q.136-.377.257-.771c.688-2.226 1.233-4.543 1.76-6.785.226-.964 1.18-5.014 1.367-5.816l.089-.329z",
    transform: "translate(1306.948 6421.054)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46336",
    d: "M32.3 6.629c2.628-2.1 4.069-3.9 6.871-6.628-.553 1.9-1.187 4.272-1.985 7.585q-.863 3.574-1.717 7.149c-2.536 10.569-4.728 21.5-8.834 31.231C20.022 61.641.582 62.126.582 62.126c12.47-4.892 20.279-14.119 22.939-23.134 3.138-10.63 5.885-21.475 8.752-32.238z",
    transform: "translate(1467.654 6444.998)",
    style: {
      fill: "#006f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46337",
    d: "M28.175 23.115c-.475 1.544-1.012 4.025-1.726 6.709-.513 1.931-.906 3.359-1.416 5.292-2.266 8.569-4.319 17.431-7.6 25.325A26.8 26.8 0 0 1 0 75.884c8.688-4.694 13.126-13.393 15.392-20.7C18.067 46.559 20.32 37 22.82 28.271l.026-.1a67.626 67.626 0 0 0 5.329-5.054",
    transform: "translate(1468 6431.251)",
    style: {
      fill: "#006f8a"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo6);
export default __webpack_public_path__ + "static/media/brand-logo-6.7ef5b594add0d7292ec9a844c915ff55.svg";
export { ForwardRef as ReactComponent };